import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalComponent } from './modal/modal.component';
import { FilterComponent } from './filter/filter.component';

@NgModule({
  declarations: [ModalComponent, FilterComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [ReactiveFormsModule, FormsModule, ModalComponent, FilterComponent],
})
export class SharedModule {}
